import { render, staticRenderFns } from "./OptimizationWidget.vue?vue&type=template&id=c8912c94&scoped=true&"
import script from "./OptimizationWidget.vue?vue&type=script&lang=js&"
export * from "./OptimizationWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8912c94",
  null
  
)

export default component.exports